webpackJsonp([125072111538023],{

/***/ 413:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.SectionLandingPageQuery = undefined;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(45);
	
	var _components2 = _interopRequireDefault(_components);
	
	var _seo = __webpack_require__(53);
	
	var _seo2 = _interopRequireDefault(_seo);
	
	var _getContents = __webpack_require__(21);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SectionLandingPage = function SectionLandingPage(_ref) {
	    var data = _ref.data;
	
	    if (!data) {
	        return _react2.default.createElement(
	            'div',
	            null,
	            'No data'
	        );
	    }
	    var page = data.page.edges[0].node;
	    var jobs = data.jobs ? data.jobs.edges : [];
	    var insights = data.insights ? data.insights.edges : [];
	    var regions = data.regions ? (0, _getContents.stripNode)(data.regions.edges) : [];
	    var locations = data.locations ? (0, _getContents.stripNode)(data.locations.edges) : [];
	    var subpageLayout = page.subpageLayout;
	
	    var seo = {
	        title: page.title,
	        description: page.body,
	        image: ''
	    };
	    page.extraModules.forEach(function (module) {
	        if (module.__typename == 'DatoCmsMiniHero') {
	            seo.image = module.image.sizes.src;
	        }
	    });
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_seo2.default, seo),
	        _react2.default.createElement(
	            'div',
	            {
	                className: 'section gray-dividers ' + (subpageLayout == true ? 'indented-contents pt-60' : '') },
	            _react2.default.createElement(_components2.default, {
	                content: {
	                    __typename: 'sidebysidetext',
	                    title: page.title,
	                    body: page.body
	                }
	            }),
	            page.extraModules && page.extraModules.map(function (module, i) {
	                return _react2.default.createElement(_components2.default, {
	                    key: i,
	                    content: module,
	                    jobs: jobs,
	                    insights: insights,
	                    regions: regions,
	                    locations: locations,
	                    ignoreIndent: true
	                });
	            })
	        ),
	        _react2.default.createElement(_components2.default, {
	            content: {
	                __typename: 'DatoCmsGiantLinkContainer',
	                links: page.links
	            }
	        })
	    );
	};
	
	exports.default = SectionLandingPage;
	var SectionLandingPageQuery = exports.SectionLandingPageQuery = '** extracted graphql fragment **';
	
	// date(formatString: "MMMM DD, YYYY")

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-section-landingpage-template-js-9ac1c937a400cc1c006d.js